import { purify } from "../../_src/components/purify";

export function getResults(url, resultId, btnDataAction) {
    var btnLoadMore = document.querySelector(`${btnDataAction}`)

    function search(loadMore) {
        btnLoadMore.classList.add("loading")

        fetch(`${url}p${btnLoadMore.getAttribute("data-page")}?&loadmore=${loadMore}`)
        .then((response) => {
            return response.text();
        }).then((response) => {
            if (loadMore) {
                document.querySelector(`${resultId}`).insertAdjacentHTML('beforeend', response);
            } else {
                document.querySelector(`${resultId}`).innerHTML = purify(response);
            }
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            btnLoadMore.classList.remove("loading")

            if (btnLoadMore.getAttribute("data-page") == btnLoadMore.getAttribute("data-total")) {
                btnLoadMore.classList.add('hidden');
            }
        });
    }

    btnLoadMore.addEventListener("click", function() { setTimeout(() => { search(true) }, 100), btnLoadMore.dataset.page = parseInt(btnLoadMore.dataset.page) + 1 }, false);
}

if (document.querySelector("#result-technicalEconomicStudies-bulletins")) {
  getResults("/ifag/dados-e-analises/ajax/technicalEconomicStudies-bulletins/", "#result-technicalEconomicStudies-bulletins", "[data-action=load-more-technicalEconomicStudies-bulletins]");
}
